import { render, staticRenderFns } from "./ChatContainer.vue?vue&type=template&id=1ce586e6&"
import script from "./ChatContainer.vue?vue&type=script&lang=js&"
export * from "./ChatContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports